<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Conversiones</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <NuevaConversionModalComponent />
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refrescar</a
              >
            </div>
            <div class="col-sm-6">
              <div class="form-inline justify-content-sm-end">
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_tienda"
                  @change="filterData"
                  style="width: 150px"
                >
                  <option value>Tiendas</option>
                  <option
                    v-for="data in tiendas"
                    :value="data.codigo"
                    v-bind:key="data.id"
                  >
                    {{ data.nombre }}
                  </option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ConversionesTableComponent :dataTabla="dataTabla" />
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ConversionesTableComponent from "@/components/inventario/conversiones/ConversionesTableComponent";
import NuevaConversionModalComponent from "@/components/inventario/conversiones/NuevaConversionModalComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    UsuarioEnTablaComponent,
    ConversionesTableComponent,
    NuevaConversionModalComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      dataTabla: "",
      params: "",
      tiendas: [],
      filtro_tienda: "",
    };
  },
  mounted() {
    let self = this;
    self.filterData();
    self.refreshTienda();
  },
  methods: {
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    refreshConversiones(params) {
      let self = this;
      DynamicService.fetch("inv", "conversion-e", params).then((response) => {
        self.dataTabla = response.data;
      });
    },
    filterData() {
      let self = this;
      this.$data.currentPage = 1;
      self.params = {
        tienda: this.filtro_tienda,
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        quitar_paginacion: true,
      };
      self.refreshConversiones(self.params);
    },
    clearFilterData() {
      let self = this;
      this.filtro_tienda = "";
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      self.params = {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        quitar_paginacion: true,
      };
      self.refreshConversiones(self.params);
    },
  },
};
</script>
